
import { defineComponent } from "@vue/runtime-core";
import { ref, onMounted } from "vue";
import { useMenu } from "@/composables/useMenu";

export default defineComponent({
  name: "TheNavbar",
  setup() {
    const showMenu = ref(true);
    const desktopMenu = ref(false);
    const menuSmall = ref(false);
    const isLoggedIn = ref(true);
    const {
      menuItems,
      mobileBreakpoint,
      smallMenuBreakpoint,
      backgroundAlwaysVisible,
    } = useMenu();

    const checkWidth = () => {
      showMenu.value =
        document.documentElement.clientWidth >= mobileBreakpoint.value;
      desktopMenu.value =
        document.documentElement.clientWidth >= mobileBreakpoint.value;
    };
    const checkScroll = () => {
      menuSmall.value = window.scrollY > smallMenuBreakpoint.value;
    };

    onMounted(() => {
      checkWidth();
      addEventListener("resize", checkWidth, true);
      addEventListener("scroll", checkScroll, true);
    });

    return {
      showMenu,
      isLoggedIn,
      menuItems,
      desktopMenu,
      menuSmall,
      backgroundAlwaysVisible,
    };
  },
});
